import React from "react";
import { FormField, CardSection } from "../../Common/FormComponents";

const PropertyLandlordSection = ({ formData, handleInputChange, isMultiUnitBuilding }) => {
  const type = formData.type;
  const grid3 = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "0.75rem" };
  const grid2 = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "0.75rem" };
  const hint = { fontSize: 12, color: "#6b7280", marginBottom: "0.75rem", lineHeight: 1.6 };

  if (isMultiUnitBuilding) {
    return (
      <CardSection title="Building owner / manager contact">
        <p style={hint}>Primary contact for this building (owner, landlord, or authorized manager).</p>
        <div style={grid3}>
          <FormField label="Name" name="buildingContactName" value={formData.buildingContactName} onChange={handleInputChange} required placeholder="Full name" />
          <FormField label="Phone" name="buildingContactPhone" value={formData.buildingContactPhone} onChange={handleInputChange} required placeholder="Phone number" />
          <FormField label="Email" name="buildingContactEmail" type="email" value={formData.buildingContactEmail} onChange={handleInputChange} placeholder="email@example.com" />
        </div>
      </CardSection>
    );
  }

  if (type === "one_time_rental") {
    return (
      <CardSection title="Landlord information">
        <p style={hint}>Contact details for the property owner or landlord you represent for this listing.</p>
        <div style={grid2}>
          <FormField label="Landlord name" name="landlordName" value={formData.landlordName} onChange={handleInputChange} required placeholder="Full name" />
          <FormField label="Landlord phone" name="landlordContact" value={formData.landlordContact} onChange={handleInputChange} required placeholder="Phone number" />
        </div>
      </CardSection>
    );
  }

  if (type === "property_management") {
    return (
      <CardSection title="Property owner information">
        <p style={hint}>Owner details for this management agreement (stored on the property record).</p>
        <div style={grid3}>
          <FormField label="Owner name" name="ownerName" value={formData.ownerName} onChange={handleInputChange} required placeholder="Full name" />
          <FormField label="Owner phone" name="ownerContact" value={formData.ownerContact} onChange={handleInputChange} required placeholder="Phone number" />
          <FormField label="Owner email" name="ownerEmail" type="email" value={formData.ownerEmail} onChange={handleInputChange} required placeholder="email@example.com" />
        </div>
      </CardSection>
    );
  }

  if (type === "sale") {
    return (
      <CardSection title="Seller information">
        <p style={hint}>Contact details for the seller (stored under sale info on the property).</p>
        <div style={grid2}>
          <FormField label="Seller name" name="sellerName" value={formData.sellerName} onChange={handleInputChange} required placeholder="Full name" />
          <FormField label="Seller phone" name="sellerContact" value={formData.sellerContact} onChange={handleInputChange} required placeholder="Phone number" />
        </div>
      </CardSection>
    );
  }

  return null;
};

export default PropertyLandlordSection;
